// @flow

import React from "react";
import { connect } from "react-redux";
import { EditorState } from "draft-js";
import { toggleContributing, addContributing } from "@src/actions";

import { Text, Flex } from "@src/common";
import { TextAreaInput } from "@src/common/textInput";

import {
  Comment,
  DraftComponent,
  Factor
} from "@src/containers/Assessment/components";
import { ContentBody, ContentHeader } from "@src/components";

import Checkbox from "material-ui/Checkbox";
import { Checked, Unchecked } from "@src/common/muiComponents/checkbox";

// Mui Checkbox style
import { muiLabelStyle } from "@src/common/theme";

const renderFactors = (factor, factorKey, factorIndex, toggleFunction) => {
  return (
    <Factor key={factorKey} onClick={toggleFunction}>
      <Checkbox
        key={`${factorKey + factorIndex}`}
        disableTouchRipple
        labelStyle={muiLabelStyle}
        style={{ width: "initial" }}
        iconStyle={{ marginRight: "10px" }}
        checked={factor.checked}
        uncheckedIcon={<Unchecked />}
        checkedIcon={<Checked />}
      />
      <Text type="book" size="5">
        {factor.text}
      </Text>
    </Factor>
  );
};

const getMetaQuestion = activeSubStep =>
  [
    {
      title: "Question for client",
      subtitle: "To help us provide the best care possible, please describe:",
      text: "If there is anything during your stay that could cause you to become agitated, upset or angry? e.g., I am agitated when…",
      shortForm: "question"
    },
    {
      title: "Question for client",
      subtitle: "To help us provide the best care possible, please describe:",
      text: "What works to prevent or reduce the behaviour(s) e.g., When I am agitated, it helps if I…",
      shortForm: "question"
    },
    {
      title: "Potential De-escalation Techniques",
      subtitle: "Identify potential de-escalation strategies based on previous information",
      text: "",
      shortForm: "technique"
    }
  ][activeSubStep];

class ContributingFactors extends React.Component {
  state = {
    editorState: EditorState.createEmpty()
  };

  onEditorEnter = (activeSubStep, factors, value) => {
    this.props.addFactor(
      activeSubStep,
      `custom${Object.keys(factors).length}`,
      value
    );
    this.clearEditor();
  };
  clearEditor = () => {
    this.setState({ editorState: EditorState.createEmpty() });
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.activeSubStep !== this.props.activeSubStep) {
      this.clearEditor();
    }
  }

  render() {
    const { section, activeSubStep, toggleContributingFactors } = this.props;
    const { subsections } = section;
    const { title, factors } = subsections[activeSubStep];
    const metaQuestion = getMetaQuestion(activeSubStep);

    return (
      <Flex justifyContent="flex-start" flexDirection="column">
        <ContentHeader backgroundColor="whiteGrey">
          <Text size={4} type="bold">
            {`${activeSubStep + 1}. ${metaQuestion.title}:`}
          </Text>
        </ContentHeader>
        <ContentHeader marginB={0} paddingV={0}>
          <Factor flexDirection="column" style={{ border: "none" }}>
            <Text size={5} type="bold">
              {metaQuestion.subtitle}
            </Text>
            <Text size={5} type="book" style={{ width: "100%" }}>
              {metaQuestion.text}
            </Text>
          </Factor>
        </ContentHeader>
        <ContentHeader backgroundColor="whiteGrey">
          <Text size={4} type="bold">
            {`${activeSubStep + 1}.1 ${title}`}
          </Text>
        </ContentHeader>
        <ContentBody
          style={{
            flexBasis: "calc(100vh - 375px)",
            minHeight: "calc(100vh - 375px)"
          }}
        >
          {Object.keys(factors).map((factorKey, factorIndex) =>
            renderFactors(factors[factorKey], factorKey, factorIndex, () => {
              toggleContributingFactors(activeSubStep, factorKey);
            })
          )}
          <DraftComponent
            editorPlaceHolder={`Add a new ${metaQuestion.shortForm}`}
            onEditorEnter={value =>
              this.onEditorEnter(activeSubStep, factors, value)}
            editorState={this.state.editorState}
            onChange={state => this.setState({ editorState: state })}
            clearEditor={this.clearEditor.bind(this)}
          />
          <Comment>
            <TextAreaInput
              placeholder="Add a comment"
              onChange={this.props.onCommentChange}
              value={this.props.commentValue}
            />
          </Comment>
        </ContentBody>
      </Flex>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return {
    toggleContributingFactors: (activeSubStep, behaviourKey) =>
      dispatch(toggleContributing(activeSubStep, behaviourKey)),
    addFactor: (activeSubStep, behaviourKey, value) =>
      dispatch(addContributing(activeSubStep, behaviourKey, value))
  };
}

export default connect(() => ({}), mapDispatchToProps)(ContributingFactors);



// WEBPACK FOOTER //
// ./src/containers/Assessment/ContentWrapper/Layouts/ContributingFactors.jsx